import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  Renderer2,
} from "@angular/core";
import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ApexAxisChartSeries,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexLegend,
  ApexXAxis,
  ApexStroke,
  ApexTitleSubtitle,
  ApexYAxis,
  ApexTooltip,
  ApexFill,
} from "ng-apexcharts";

// export type ChartOptions = {
//   series: ApexNonAxisChartSeries;
//   chart: ApexChart;
//   responsive: ApexResponsive[];
//   labels: any;
// };

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
  fill: ApexFill;
  legend: ApexLegend;
};

export type GatewiseChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
  fill: ApexFill;
  legend: ApexLegend;
};
export type ProgressChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  subtitle: ApexTitleSubtitle;
};
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { CommonService } from "../../services/common/common.service";
import { environment } from "../../../../src/environment/environment";
import { SubTitle } from "chart.js";
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
  @ViewChild("dropdownMenu") dropdownMenu!: ElementRef;
  @ViewChild("dropdownButton") dropdownButton!: ElementRef;
  // @ViewChild("chart") chart!: ChartComponent;
  public GatewiseChartOptions: Partial<GatewiseChartOptions> | any;
  public ProgressChartOptions: Partial<ProgressChartOptions> | any;
  public chartOptions: Partial<ChartOptions> | any;
  // public chartOptions: Partial<ChartOptions> | any;
  // public GateWiseStatusChartOptions: Partial<GateWiseStatusChartOptions> | any;
  proposalFrm: any = [];
  submitted: any;
  type: any = "pie";
  options: any = {};
  optionsSupportTicketSummery: any = {};
  data: any = {};
  dataSupportTicketSummery: any = {};
  customer_id: any;
  soList: any;
  supportTicketSummery = true;
  customerActionLogsId: any;
  selectedSoNumber: any;
  selectedSoNumberProjectNo: any;
  payload: any;
  taskList: any;
  taskListData: any;
  chat_visibility: boolean = false;
  lastGateName: any;
  nextGateName: any;
  constructor(
    private CommonService: CommonService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private _formBuilder: FormBuilder,
    private renderer: Renderer2
  ) {}
  ngOnInit() {
    this.lastGateName = "Project yet to start";
    this.route.params.subscribe((params) => {
      this.customer_id = localStorage.getItem("customerId");
      this.customerActionLogsId = localStorage.getItem("customerActionLogsId");
      const payload = {
        modelName: "department",
        whereCondition: {
          client_id: this.customer_id,
          inactive: 1,
        },
        pagination: {
          pageSize: 10000,
          page: 1,
        },
      };
      this.CommonService.getRecords(payload).subscribe((e: any) => {
        this.soList = e.data;

        if (this.soList.length != 0) {
          // this.chat_visibility = this.soList.some(
          //   (record: any) => record.chat_enabled === 1 && record.assistant_id
          // );
          // this.selectedSoNumber = this.soList[0].id;
          // this.selectedSoNumberProjectNo = this.soList[0].name;
          // Retrieve the saved SO number from localStorage
          const savedSoNumber = localStorage.getItem('selectedSoNumber');

            if (savedSoNumber) {              
              this.selectedSoNumber = Number(savedSoNumber);              
              // Find the corresponding project name from the soList
              const selectedProject = this.soList.find((so:any) => so.id === this.selectedSoNumber);
              this.selectedSoNumberProjectNo = selectedProject ? selectedProject.name : 'Select SO No';
              if(selectedProject && selectedProject.chat_enabled === 1 && selectedProject.assistant_id){
                this.chat_visibility = true;
              } else {
                this.chat_visibility = false;
              }
            } else if (this.soList.length > 0) {
              // If no saved value, default to the first item in the list
              this.selectedSoNumber = this.soList[0].id;
              this.selectedSoNumberProjectNo = this.soList[0].name;
              
              if(this.soList[0].chat_enabled === 1 && this.soList[0].assistant_id){                
                this.chat_visibility = true;
              } else {
                this.chat_visibility = false;
              }
            }

          environment.projectName = this.selectedSoNumberProjectNo;
          this.proposalFrm.controls["soNumber"].setValue(this.soList[0].id);
          this.cdr.detectChanges();
          this.projectProjectProgressPieChart(this.selectedSoNumber);
        }
      });
      this.getPendingTaskList(this.customer_id);
    });

    this.proposalFrm = this.createCustomerForm();
  }
  trackById(index: number, item: any) {
    return item.id; // Return the unique identifier (id)
  }

  // so: { id: string; name: string }
  onSelectSoNumber(so: any): void {
    this.selectedSoNumber = so.id;
    this.selectedSoNumberProjectNo = so.name;
    // localStorage.setItem('selectedSoNumber', this.selectedSoNumber); // Store in localStorage
    localStorage.setItem('selectedSoNumber', String(this.selectedSoNumber));
    environment.projectName = this.selectedSoNumberProjectNo;
    this.proposalFrm.controls["soNumber"].setValue(so.id);
    this.getPoData(so.id);
    // this.closeDropdown();
    if(so.chat_enabled === 1 && so.assistant_id){
      this.chat_visibility = true;
    } else {
      this.chat_visibility = false;
    }
  }
  getPendingTaskList(custID: any) {
    this.payload = {
      modelName: "employee_tasks",
      whereCondition: {
        customer_name: custID,
        user_type: 2,
        // as per discussion with aditya sir need to comment this
        // "status": {
        //   "in": [
        //     "1",
        //     "2"
        //   ]
        // }
      },
      orderByModelWise: { field: "id", order: "asc" },
      pagination: {
        pageSize: 10000,
        page: 1,
      },
      relations: [
        {
          module: "department",
          moduleAs: "department",
        },
      ],
    };
    this.CommonService.getRecords(this.payload).subscribe((response: any) => {
      if (response.code == 1) {
        if (response.data.length > 0) {
          this.taskList = response.data;
          this.taskListData = true;
        }
      }
    });
  }
  projectProjectProgressPieChart(id: any) {
    this.payload = {
      modelName: "project_details",
      whereCondition: {
        project_id: this.selectedSoNumber,
        // is_timesheet_task : false,
      },
      pagination: {
        pageSize: 10000,
        page: 1,
      },
      // orderBy: {
      //   field: "id",
      //   order: "asc",
      // },
      orderByModelWise: { field: "milestone_master.milestone", order: "asc" },
      // 👇 Add this part for filtering relation
      // moduleWhereCondition: {
      //   is_timesheet_task: 0,
      // },
      relations: [
        {
          module: "milestone_master",
          moduleAs: "milestone_master",
          // isModuleWhereConditionRequired: true, // 👈 tells function to apply moduleWhereCondition
        },
      ],
    };
    this.CommonService.getRecords(this.payload).subscribe((response: any) => {
      const milestones = new Map();
      let totalTasks = 0;
      let completedTasks = 0;
      let currentMilestoneTotalTasks = 0;
      let currentMilestoneCompletedTasks = 0;

      // ✅ Filter data to remove tasks with no milestone
      const filteredData = response.data.filter(
        (task: any) =>
          task.milestone_master &&
          task.milestone_master.milestone &&
          task.is_timesheet_task !== 1
      );

      filteredData.forEach((task: any) => {
        const milestone = task.milestone_master.milestone;
        const status = task.status;
        const completionPercentage = task.completionpercentage;

        if (["Cancelled", "Completed", "On Hold"].includes(status)) {
          this.lastGateName = milestone;
        }

        totalTasks++;
        if (!milestones.has(milestone)) {
          milestones.set(milestone, {
            milestone,
            open: 0,
            workInProgress: 0,
            onHold: 0,
            cancelled: 0,
            completed: 0,
            completedGroup: 0,
            remaining: 0,
            total: 0,
          });
        }

        const milestoneData = milestones.get(milestone);

        switch (status) {
          case "Open":
            milestoneData.open++;
            milestoneData.remaining++;
            break;
          case "Work In Progress":
            milestoneData.workInProgress++;
            milestoneData.remaining++;
            break;
          case "On Hold":
            milestoneData.onHold++;
            milestoneData.remaining++;
            break;
          case "Cancelled":
            milestoneData.cancelled++;
            milestoneData.completedGroup++;
            completedTasks += completionPercentage;
            break;
          case "Completed":
            milestoneData.completed++;
            milestoneData.completedGroup++;
            completedTasks += completionPercentage;
            break;
          default:
            milestoneData.remaining++;
        }

        milestoneData.total++;
      });

      const sortedMilestones = Array.from(milestones.keys());
      const currentIndex = sortedMilestones.indexOf(this.lastGateName);
      const nextMilestone =
        currentIndex >= 0 && currentIndex < sortedMilestones.length - 1
          ? sortedMilestones[currentIndex + 1]
          : sortedMilestones[0];

      this.nextGateName = nextMilestone;

      const completedGroupData: number[] = [];
      const remainingData: number[] = [];
      const categoriesGatewise: string[] = [];

      const openData: number[] = [];
      const workInProgressData: number[] = [];
      const onHoldData: number[] = [];
      const cancelledData: number[] = [];
      const completedDataForChart: number[] = [];
      const categoriesAllStatuses: string[] = [];

      Array.from(milestones.values()).forEach((milestoneData) => {
        completedGroupData.push(milestoneData.completedGroup);
        remainingData.push(milestoneData.remaining);
        categoriesGatewise.push(milestoneData.milestone);

        openData.push(milestoneData.open);
        workInProgressData.push(milestoneData.workInProgress);
        onHoldData.push(milestoneData.onHold);
        cancelledData.push(milestoneData.cancelled);
        completedDataForChart.push(milestoneData.completed);
        categoriesAllStatuses.push(milestoneData.milestone);
      });

      // Calculate progress for current milestone
      filteredData.forEach((task: any) => {
        if (
          task.milestone_master &&
          task.milestone_master.milestone === this.lastGateName
        ) {
          currentMilestoneTotalTasks++;
          if (["Completed", "Cancelled"].includes(task.status)) {
            currentMilestoneCompletedTasks++;
          }
        }
      });

      const progressPercentage =
        currentMilestoneTotalTasks > 0
          ? Math.round(
              (currentMilestoneCompletedTasks / currentMilestoneTotalTasks) * 100
            )
          : 0;

      // Chart configuration
      this.GatewiseChartOptions = {
        series: [
          {
            name: "Completed Tasks",
            data: completedGroupData,
          },
          {
            name: "Remaining Tasks",
            data: remainingData,
          },
        ],
        chart: {
          type: "bar",
          height: 340,
          stacked: true,
          toolbar: {
            show: true,
            tools: { download: true },
            export: {
              csv: {
                filename: `Gate Wise Status Of - ${this.selectedSoNumberProjectNo}`,
                headerCategory: "Category",
              },
              svg: {
                filename: `Gate Wise Status Of - ${this.selectedSoNumberProjectNo}`,
              },
              png: {
                filename: `Gate Wise Status Of - ${this.selectedSoNumberProjectNo}`,
              },
            },
          },
        },
        title: {
          text: "SO Number (Project Name) - " + this.selectedSoNumberProjectNo,
          align: "center",
          style: {
            fontSize: "13px",
            marginTop: "10px",
            fontWeight: 600,
            color: "#878787",
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "60%",
            minHeight: 0,
          },
        },
        xaxis: {
          categories: categoriesGatewise,
          tickAmount: 1,
          labels: { style: { fontSize: "12px" } },
        },
        yaxis: { labels: { maxWidth: 500 } },
        colors: ["#00E396", "#FF4560"],
        legend: { position: "top", horizontalAlign: "center" },
        tooltip: {
          shared: true,
          intersect: false,
          y: { formatter: (value: number) => `${value} Tasks` },
        },
        stroke: { width: 0 },
        dataLabels: {
          enabled: true,
          formatter: (value: number) => (value > 0 ? `${value}` : ""),
        },
        grid: { padding: { left: 20, right: 20 } },
      };
      // Configure chartOptions (Unchanged)
      this.chartOptions = {
        series: [
          {
            name: "Open Tasks",
            data: openData,
          },
          {
            name: "Work In Progress",
            data: workInProgressData,
          },
          {
            name: "On Hold Tasks",
            data: onHoldData,
          },
          {
            name: "Cancelled Tasks",
            data: cancelledData,
          },
          {
            name: "Completed Tasks",
            data: completedDataForChart,
          },
        ],
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: true, 
            tools: {
              download: true, 
            },
            export: {
              csv: {
                filename: `Detailed Task Status Gate wise - ${this.selectedSoNumberProjectNo}`, // CSV download filename
                headerCategory: "Category"
              },
              svg: {
                filename: `Detailed Task Status Gate wise - ${this.selectedSoNumberProjectNo}`, // SVG download filename
              },
              png: {
                filename: `Detailed Task Status Gate wise - ${this.selectedSoNumberProjectNo}`, // PNG download filename
              },
            },
          }
        },
        title: {
          text: "SO Number (Project Name) - " + this.selectedSoNumberProjectNo, // Title text
          align: "center", // Align the title in the center
          style: {
            fontSize: "13px", // Font size for the title
            marginTop: "10px",
            fontWeight: 600,
            color: "#878787", // Title color
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "60%", // Adjust the bar height
          },
        },
        xaxis: {
          categories: categoriesAllStatuses, // Use dynamic milestone names
          tickAmount: 1, // Number of ticks on the X-axis
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          labels: {
            maxWidth: 500,
          },
        },
        colors: ["#00A5E3", "#FFC107", "#FFA500", "#FF4560", "#00E396"], // Colors for each status
        legend: {
          position: "top",
          horizontalAlign: "center",
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: (value: number) => `${value} Tasks`,
          },
        },
        stroke: {
          width: 0, // No border around bars // Rajesh  - no bar for zero
        },
        dataLabels: {
          enabled: true,
          formatter: (value: number) =>
            value > 0 ? `${Math.round(value)}` : "", // Show integer value if > 0
        },
        grid: {
          padding: {
            left: 20,
            right: 20,
          },
        },
      };

      //configure overallrpogressreport
      // Configure Project Progress Chart
      this.ProgressChartOptions = {
        series: [progressPercentage],
        chart: {
          type: "radialBar",
          height: 340,
        },
        title: {
          text: "Current Phase Status: " + this.lastGateName,
          align: "center",
          style: {
            fontSize: "13px",
            marginTop: "10px",
            fontWeight: 600,
            color: "#878787",
          },
        },
        subtitle: {
          text: "Next Phase: " + this.nextGateName,
          align: "center",
          style: {
            fontSize: "11px",
            fontWeight: 600,
            color: "#878787",
          },
        },
        plotOptions: {
          radialBar: {
            hollow: {
              size: "70%",
            },
            dataLabels: {
              name: {
                show: true,
                fontSize: "16px",
                fontWeight: "bold",
                color: "#333",
                offsetY: -10,
                text: "Project Progress",
              },
              value: {
                show: true,
                fontSize: "24px",
                fontWeight: "bold",
                color: "#00E396",
                formatter: (val: number) => `${val}%`,
              },
            },
          },
        },
        labels: ["Completed"],
        colors: ["#00E396"],
        legend: {
          show: false,
        },
      };
    });
  }
  closeDropdown(): void {
    const dropdown = this.dropdownMenu.nativeElement;
    const button = this.dropdownButton.nativeElement;
    this.renderer.removeClass(this.dropdownMenu.nativeElement, "show");
    if (dropdown.classList.contains("show")) {
      dropdown.classList.remove("show");
      button.setAttribute("aria-expanded", "false");
    }
  }
  createCustomerForm(): FormGroup {
    return (this.proposalFrm = this._formBuilder.group({
      soNumber: ["", Validators.required],
      soNumberForReport: [""],
    }));
  }
  onChartClick(event: any) {
    console.log(event);
  }
  getPoData(id: any) {
    this.projectProjectProgressPieChart(id);
  }
  onSubmit() {
    if (!this.selectedSoNumber) {
      Swal.fire({
        // position: "top-end",
        icon: "warning",
        title: "Pleae select SO No. (Project Name) Number.",
        // showConfirmButton: false,
        // timer: 1500,
      });
    } else {
      var data = environment.url;
      var url =
        "/customers/masters/saveReportConcise?project_id=" +
        this.selectedSoNumber +
        "&flag=0&customerActionLogsId=" +
        this.customerActionLogsId;
      // const reportUrl = "https://example.com/download/report"; // Replace this with your report URL
      window.open(data + url, "_blank");
    }
  }
  openchatwindow() {
    this.router.navigate(["/chat"]);
  }
  openComplaint(recordID: any, type: any) {
    if (type == 2) {
      this.router.navigate(["/ComplaintsView/", recordID], { queryParams: { fromDashboard:true } });
    } else {
      let action = "Add";
      this.router.navigate(["/ComplaintsCreate", action], { queryParams: { fromDashboard:true } });
    }
  }
}
